export enum PRESET_PROPERTY_CATEGORY {
    Data = 'Data',
    Columns='Columns',
    Basic = 'Basic',
    Behavior = 'Behavior',
    Layout = 'Layout',
    Style = 'Style',
};

